export type TranslatedLabel = {
  en: string;
  de: string;
  fr: string;
  it: string;
};

export enum OdometerSource {
  Can = 1,
  Tco = 2,
  Gps = 3,
}

export type ColumnTemplate = {
  name: TranslatedLabel;
  has_hover: false;
  hover: TranslatedLabel;
  default: string;
  unit: string | null;
  scale_factor: number | null;
  digits_after_comma: number | null;
  values_mapping_name: string | null;
  type: string | null;
};

export type RawVehicleTemplate = {
  _id: string;
  name: string;
  description: string;
  all_columns: Record<string, ColumnTemplate>;
  default_columns: string[];
  ignition_value: any;
  is_digital: string[] | null;
  tags: string[];
  companies: string[];
  owner: string;
  is_default_template: boolean;
  created: string;
  modified: string;
  display_columns: string[] | null;
  error_codes_mapping_name: string | null;
  internal_tariff_id: string | null;
  odometer_source: OdometerSource;
};
